import { render, staticRenderFns } from "./musicVersion.vue?vue&type=template&id=7093e073&scoped=true"
import script from "./musicVersion.vue?vue&type=script&lang=js"
export * from "./musicVersion.vue?vue&type=script&lang=js"
import style0 from "./musicVersion.vue?vue&type=style&index=0&id=7093e073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7093e073",
  null
  
)

export default component.exports